import React, { FunctionComponent } from 'react';
import { Field, FormikHelpers } from 'formik';
import { WeekdaySelection } from '@/components/WeekdaySelection/WeekdaySelection';
import { FieldInputProps } from 'formik/dist/types';

type WeekdaySelectFormikWrapperProps = {
    form: FormikHelpers<Set<string>>;
    field: FieldInputProps<Set<string>>;
};

const WeekdaySelectFormikWrapper: FunctionComponent<
    React.PropsWithChildren<WeekdaySelectFormikWrapperProps>
> = ({ form, field }) => {
    const { setFieldValue } = form;
    const { value, name } = field;

    return (
        <WeekdaySelection
            selectedWeekdays={Array.from(value)}
            onSelect={(weekday) => {
                const copySet = new Set(value);
                copySet.add(weekday);
                setFieldValue(name, copySet);
            }}
            onUnSelect={(weekday) => {
                const copySet = new Set(value);
                copySet.delete(weekday);
                setFieldValue(name, copySet);
            }}
        />
    );
};

type WeekdaySelectFieldProps = {
    name: string;
};

export const WeekdaySelectField: FunctionComponent<
    React.PropsWithChildren<WeekdaySelectFieldProps>
> = ({ name }) => {
    return <Field name={name} component={WeekdaySelectFormikWrapper} />;
};
